"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Upgraded modals logic.
 * 
 * 1) It can be opened with <a data-modal="Some title" href="/some-link">Hello</a>
 * 
 * 2) If modal opened within modal and you want to keep old title then use
 * "data-modal-keep-title" attribute or set empty "data-modal".
 * 
 * 3) To open large modal add "data-modal-xl" attribute.
 * 
 * 4) Use "data-href" if you open modal from from <div> or <span> or any not <a> element.
 * 
 * 5) Links inside the modal will be opened in the same modal if they meet 2 conditions:
 *  - link has no "data-method" attribute
 *  - link url returns partial HTML - without main layout
 * 
 * @method FlixModal.open()
 * @method FlixModal.close()
 * @method FlixModal.reload()
 * @method FlixModal.openWithUrl()
 */
var FlixModal = function () {
  var FlixModal = {};
  var modal = null;
  var ajaxRequestCompleted = false;
  var currentUrl = null;
  var currentData = {};
  var currentTitle = null;

  /**
   * Make AJAX request to `url` and show modal with response body if there is no <head>
   * in it (partial request).
   * If <head> presented in response then it will just redirect to `url`.
   * 
   * @param {string} url
   * @param {string} method HTTP method (GET, POST, etc)
   * @param {string|null} title 
   * @param {object} data Form data
   * @param {bool} isFileUpload Form data
   */
  FlixModal.openWithUrl = function (url, method) {
    var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isFileUpload = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    ajaxRequestCompleted = false;
    setTimeout(function () {
      if (!ajaxRequestCompleted) {
        FlixModal.open('<div class="text-center"><div class="spinner-border"></div></div>', title);
      }
    }, 200);
    FlixUtils.request(url, {
      returnXHR: true,
      method: method,
      data: data
    }).then(function (xhr) {
      ajaxRequestCompleted = true;
      var response = xhr.parsedResponse;
      FlixModal.close(); // Clean stuff after <form> success redirects

      if (_typeof(response) === "object") {
        // if JSON with command returned
        if (response.reload) {
          if (typeof Turbolinks != 'undefined' && Turbolinks.supported) {
            Turbolinks.ScrollManager.disableOnce();
            Turbolinks.visit(response.redirect, {
              action: 'replace'
            });
          } else {
            window.location.reload();
          }
        } else if (response.redirect) {
          if (typeof Turbolinks != 'undefined' && Turbolinks.supported) {
            Turbolinks.visit(response.redirect);
          } else {
            window.location.href = response.redirect;
          }
        } else if (response.command) {
          Function(response.command)();
        } else {
          alert('Invalid modal response object. Try to reload page and write us about this problem');
        }
      } else if (response.indexOf('<head>') != -1) {
        // if full page returned
        window.location.href = url;
      } else {
        // if partial returned - this is what we expect
        FlixModal.open(response, title);
        if (xhr.getResponseHeader('Turbolinks-Location')) {
          currentUrl = xhr.getResponseHeader('Turbolinks-Location');
        } else {
          currentUrl = url;
          if (method.toUpperCase() == 'GET') {
            currentData = data;
          }
        }
      }
    })["catch"](function (err) {
      FlixStats.increment('modal_request_error');
      ajaxRequestCompleted = true;
      alert('Something goes wrong. ' + err);
      FlixModal.close();
    });
  };

  /**
   * Open modal window
   * 
   * @param {string} body 
   * @param {string|null} title 
   */
  FlixModal.open = function (body) {
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    FlixModal.close();
    modal = new bootstrap.Modal('#main-modal');
    currentTitle = title;
    if (title !== null) {
      document.querySelector('#main-modal .modal-title').innerHTML = title;
    }
    document.querySelector('#main-modal .modal-body').innerHTML = body;
    modal.show();
  };

  /**
   * If modal opened with `openWithUrl(url)` then it will be reloaded with GET response
   * form same `url`
   */
  FlixModal.reload = function () {
    if (currentUrl) {
      FlixModal.openWithUrl(currentUrl, 'GET', currentTitle, currentData);
    }
  };

  /**
   * Close modal
   */
  FlixModal.close = function () {
    // $('#main-modal').off('hidden.bs.modal');

    document.querySelector('#main-modal .modal-title').innerHTML = '';
    document.querySelector('#main-modal .modal-body').innerHTML = '';
    currentUrl = null;
    currentData = {};
    currentTitle = null;

    // Try catch because of setTimeout() in openWithUrl()
    // It might try to open/close modal when it's opened/closed by ajax
    try {
      if (modal !== null) {
        modal.hide();
      }
    } catch (error) {
      console.error(error);
    }
    document.querySelectorAll('.modal-backdrop').forEach(function (el) {
      return el.remove();
    });
  };

  /**
   * Register event handler for modal
   */
  var init = function init() {
    document.querySelector('#main-modal').addEventListener('hidden.bs.modal', FlixModal.close);

    // Links that should open modal window with links target content
    // Links inside modal should open content in same modal
    document.addEventListener('click', function (e) {
      var _elem$getAttribute;
      /** @type HTMLElement */
      var elem = e.target.closest('[data-modal]');
      if (!elem) {
        // Links in modal should be opened within same modal
        elem = e.target.closest('#main-modal a:not([data-method])');
        if (!elem) {
          return;
        }
      }
      e.preventDefault();
      var title = elem.getAttribute('data-modal');
      if (!title) {
        title = elem.textContent.trim();
      }
      if (!isNaN(title) || title.length == 0 || elem.getAttribute('data-modal-keep-title')) {
        title = currentTitle;
      } else {
        currentTitle = title;
      }

      // If it's link with "data-modal"
      if (elem.getAttribute('data-modal')) {
        // If modal should be large
        if (elem.hasAttribute('data-modal-xl')) {
          document.querySelector('#main-modal .modal-dialog').classList.add('modal-xl');
        } else {
          document.querySelector('#main-modal .modal-dialog').classList.remove('modal-xl');
        }
      }
      FlixModal.openWithUrl((_elem$getAttribute = elem.getAttribute('href')) !== null && _elem$getAttribute !== void 0 ? _elem$getAttribute : elem.getAttribute('data-href'), 'GET', title);
    });

    // Forms submission inside modal window
    document.addEventListener('submit', function (e) {
      /** @type HTMLElement */
      var elem = e.target.closest('#main-modal form');
      if (!elem) {
        return;
      }
      e.preventDefault();
      FlixModal.openWithUrl(elem.getAttribute('action'), elem.getAttribute('method'), currentTitle, new FormData(elem), elem.getAttribute('enctype') == 'multipart/form-data');
    });
  };
  init();
  return FlixModal;
}();